<template>
  <div class="ps-text-area">
    <div v-if="label" class="pb-2">{{ $t(label) }}</div>
    <v-textarea
      v-model="model"
      :placeholder="$t(placeholder)"
      color="primary"
      :rows="rows"
      :flat="flat"
      :rounded="rounded"
      :outlined="outlined"
      :dense="dense"
      :disabled="disabled"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :counter="counter"
      :filled="filled"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    flat: { type: Boolean, default: false },
    label: { type: String, require: true },
    errorMessages: { type: Array, require: true },
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    counter: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    rows: { type: Number, default: 3 },
    placeholder: { type: String, default: "" },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.model = newVal;
    },
    model(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
  computed: {
    hideDetails() {
      if (this.errorMessages && this.errorMessages.length) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style></style>
